import type { ReactElement } from "react"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import BenefitCard from "@gatsby-plugin-generic-page/components/BenefitCard"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { CardsGridSectionFlatData } from "@gatsby-plugin-generic-page/fragments/cardsGridSection"
import getGapClass from "@gatsby-plugin-generic-page/helpers/getGapClass"
import { cn } from "~/helpers/cn"
import isEmpty from "~/lib/isEmpty"

const GRID_COLS_CLASS: Record<string, string> = {
  "1": "grid-cols-1",
  "2": "grid-cols-1 md:grid-cols-2",
  "3": "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  "4": "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
  "5": "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5",
}

export default function CardsGridSection({
  header,
  cards,
  columnCount,
  gap,
  lastCardFullWidthOnMd,
  sectionSettings,
}: CardsGridSectionFlatData): ReactElement<CardsGridSectionFlatData> {
  const gridColsClass =
    GRID_COLS_CLASS[columnCount ?? "3"] ?? GRID_COLS_CLASS["3"]
  const gapClass = getGapClass(gap)

  const stretchLastCard = lastCardFullWidthOnMd && cards.length % 2 !== 0

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <div className="mb-7">
            <Header {...header} />
          </div>
        ) : null}

        <div className={cn("grid", gridColsClass, gapClass)}>
          {cards.map((card, index) => (
            <BenefitCard
              key={`${card.flatData.title}-${index}`}
              {...card.flatData}
              className={cn(
                stretchLastCard &&
                  index === cards.length - 1 &&
                  "md:col-span-2 lg:col-span-1"
              )}
            />
          ))}
        </div>
      </BaseContainer>
    </BaseSection>
  )
}
